export const environment = {
	prod: false,
	url: 'https://apidev.paycitycloud.com'
};
